import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LoadingOverlay, useAlert } from '../../components';
import { updatePassword, setFundPassword } from '../../services/authService';
import { isValidPassword, isValidFundPassword } from '../../utils/helpers';
import './SecurityScreen.css';

export const SecurityScreen = () => {
    const navigate = useNavigate();
    const { userData, refreshUserData } = useAuth();
    const alert = useAlert();

    const [activeTab, setActiveTab] = useState('login'); // 'login' or 'withdrawal'
    const [loading, setLoading] = useState(false);

    // Form states
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleUpdate = async () => {
        if (!newPassword.trim() || !confirmPassword.trim()) {
            alert.showError('Error', 'Please fill all fields');
            return;
        }

        if (newPassword !== confirmPassword) {
            alert.showError('Error', 'Passwords do not match');
            return;
        }

        setLoading(true);
        try {
            if (activeTab === 'login') {
                if (!isValidPassword(newPassword)) {
                    throw new Error('Password must be at least 6 characters');
                }
                await updatePassword(newPassword);
                alert.showSuccess('Success', 'Login password updated successfully');
            } else {
                if (!isValidFundPassword(newPassword)) {
                    throw new Error('Withdrawal password must be 6 digits');
                }
                await setFundPassword(newPassword);
                await refreshUserData();
                alert.showSuccess('Success', 'Withdrawal password updated successfully');
            }

            // Clear fields
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (error) {
            alert.showError('Error', error.message || 'Update failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="security-screen-modern">
            <div className="security-header-nav">
                <button className="back-btn-security" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="security-title-nav">SECURITY CENTRE</h1>
            </div>

            <div className="security-content-area">
                {/* Tabs / Segments */}
                <div className="security-tabs-container">
                    <button
                        className={`security-tab ${activeTab === 'login' ? 'active' : ''}`}
                        onClick={() => setActiveTab('login')}
                    >
                        LOGIN PASSWORD
                    </button>
                    <button
                        className={`security-tab ${activeTab === 'withdrawal' ? 'active' : ''}`}
                        onClick={() => setActiveTab('withdrawal')}
                    >
                        WITHDRAWAL PASSWORD
                    </button>
                </div>

                <div className="security-form">
                    <div className="security-input-group">
                        <label className="security-input-label">CURRENT PASSWORD</label>
                        <input
                            type="password"
                            className="security-input-field"
                            placeholder="Enter old password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                        />
                    </div>

                    <div className="security-input-group">
                        <label className="security-input-label">NEW PASSWORD</label>
                        <input
                            type="password"
                            className="security-input-field"
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </div>

                    <div className="security-input-group">
                        <label className="security-input-label">CONFIRM NEW PASSWORD</label>
                        <input
                            type="password"
                            className="security-input-field"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>

                    <button className="security-update-btn" onClick={handleUpdate} disabled={loading}>
                        {loading ? 'UPDATING...' : `UPDATE ${activeTab.toUpperCase()} PASSWORD`}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SecurityScreen;
